import { render, staticRenderFns } from "./MyPageItem.vue?vue&type=template&id=980b998a&"
import script from "./MyPageItem.vue?vue&type=script&lang=ts&"
export * from "./MyPageItem.vue?vue&type=script&lang=ts&"
import style0 from "./MyPageItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VInput } from 'vuetify/lib/components/VInput';
installComponents(component, {VCard,VDivider,VInput})
